export interface JobPosting {
  id: string;
  title: string;
  description: string;
  requirements: string;
  location: string;
  employment_type: string;
  salary_min: number | null;
  salary_max: number | null;
  hourly_rate_min: number | null;
  hourly_rate_max: number | null;
  experience_level: string;
  is_active: boolean;
  expires_at: string | null;
  created_at: string;
  applicationCount?: number;
  qr_codes?: {
    id: string;
    name: string;
    unique_url_path: string;
    url: string;
    type: string;
  }[];
}

export interface FormField {
  id: string;
  label: string;
  type: 'text' | 'textarea' | 'email' | 'phone' | 'select' | 'checkbox';
  required: boolean;
  placeholder?: string;
  options?: string[];
  order: number;
}

export interface JobFormData {
  title: string;
  description: string;
  requirements: string;
  location: string;
  employment_type: string;
  salary_min: string;
  salary_max: string;
  hourly_rate_min: string;
  hourly_rate_max: string;
  benefits: string;
  schedule_requirements: string;
  experience_level: string;
  expires_at: string;
  // Contract management fields
  requires_contract: boolean;
  default_contract_template_id: string;
  contract_auto_generate: boolean;
}

export const defaultFormFields: FormField[] = [
  { id: 'firstName', label: 'First Name', type: 'text', required: true, order: 1 },
  { id: 'lastName', label: 'Last Name', type: 'text', required: true, order: 2 },
  { id: 'email', label: 'Email Address', type: 'email', required: true, order: 3 },
  { id: 'phone', label: 'Phone Number', type: 'phone', required: false, order: 4 },
  { id: 'workExperience', label: 'Work Experience', type: 'textarea', required: false, placeholder: 'Describe your relevant work experience...', order: 5 },
  { id: 'education', label: 'Education', type: 'textarea', required: false, placeholder: 'Describe your educational background...', order: 6 },
  { id: 'skills', label: 'Skills', type: 'textarea', required: false, placeholder: 'List your relevant skills...', order: 7 },
  { id: 'availability', label: 'Availability', type: 'textarea', required: false, placeholder: 'When can you start? What are your preferred hours?', order: 8 }
];

export const employmentTypes = [
  { value: 'full-time', label: 'Full-time' },
  { value: 'part-time', label: 'Part-time' },
  { value: 'contract', label: 'Contract' },
  { value: 'temporary', label: 'Temporary' },
  { value: 'internship', label: 'Internship' }
];

export const experienceLevels = [
  { value: 'entry-level', label: 'Entry Level' },
  { value: 'mid-level', label: 'Mid Level' },
  { value: 'senior-level', label: 'Senior Level' },
  { value: 'executive', label: 'Executive' }
];